import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMembershipsOnboardingQuery = createQueryHook(
  MembershipsCreatorApiClient.getOnboarding,
  {
    queryKey: ['membershipsOnboarding'],
  },
)
